import React, { Component } from 'react';


class ModalEjecucionEnProcesos extends Component {

    constructor(props) {
        super(props);
    }


    render() {

        const { data } = this.props;
        var mensaje = "";

        if (this.props.nombreProceso) {
            mensaje = <p>Actualmente se encuentra el proceso <strong> {this.props.nombreProceso} </strong> en ejecución, aguarde a su finalización para volver a intentarlo</p>;
        } else {
            mensaje = <p>{this.props.mensaje}</p>;
        }

        return (
            <div className='modalContainer'>
                <div className="modalDemandaOutXS">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => this.props.mostrarModal(5, false)} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title">Tablero de Procesos</h2>
                        </div>

                        <div className="modal-body">{mensaje}</div>
                        <div className="modal-footer"> <div className="row">
                            <div className="col-xs-7">
                                <button type="button" className="btn btn-secondary" onClick={() => this.props.mostrarModal(5, false)} data-dismiss="modal">Cerrar</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalEjecucionEnProcesos;   